<template>
  <div id="order-detail">
    <loading :show="isLoadingDetail" />

    <!-- <div class="box order-header" v-if="orderDetail.id">
            <div :class="[orderDetail.extra&&orderDetail.extra.isMarriage?'hun-image-container':'order-image-container']">
                <img :src="headImageUrl" alt="order-image">
            </div>

            <div class="order-info">
                <div class="info-line">
                    <div class="spec-name">{{orderDetail['description']}}</div>
                    <div class="order-status">{{orderStates[orderDetail['state']]}}</div>
                </div>

                <button class="btn btn-small save-btn"
                        @click="showPopup(true)"
                        v-if="canSave">保存电子照
                </button>
            </div>
        </div> -->
    <div class="box" v-if="orderDetail.id">
      <div class="top">
        证件照信息
        <div class="topr">{{ orderStates[orderDetail["state"]] }}</div>
      </div>
      <div class="middle">
        <oditem
          :img="headImageUrl"
          :hunbol="hunbol"
          :specName="orderDetail['description']"
          :quantity="orderDetail['quantity']"
          :price="orderDetail['price']"
        ></oditem>
      </div>
      <div class="bottom" v-if="orderDetail.append_orders.length > 0">
        <p class="btitle">加印照片</p>
        <div
          class="blistwrap"
          v-for="item in orderDetail.append_orders"
          :key="item.id"
        >
          <oditem
            :img="item.single_url"
            :hunbol="hunbol"
            :specName="item.spec_name + '（' + item.color + '）'"
            :quantity="item.quantity"
            :price="item.price"
          ></oditem>
        </div>
      </div>
    </div>
    <div class="box" v-if="orderDetail.id">
      <div class="card-title">订单信息</div>
      <div class="card-body">
        <div class="card-item card-item-with-button">
          <span class="left">订单编号 : {{ orderDetail["order_no"] }}</span>
          <button
            class="btn btn-small cp-btn clip-btn"
            :data-clipboard-text="orderDetail['order_no']"
          >
            复制
          </button>
        </div>
        <div class="card-item" v-if="orderDetail['state'] === 'waiting'">
          下单时间 : {{ orderTime }}
        </div>
        <div class="card-item" v-else>付款时间 : {{ payedTime }}</div>
        <div class="card-item">
          冲印版数 : {{ orderDetail["total_quantity"] }}
        </div>
        <div class="card-item" v-if="orderDetail['formal_wear_price']">
          个性换正装 : ¥{{
            (orderDetail["formal_wear_price"] / 100).toFixed(2)
          }}
        </div>
        <div class="card-item" v-if="orderDetail['fine_price']">
          证件照精修 : ¥{{ (orderDetail["fine_price"] / 100).toFixed(2) }}
        </div>

        <template v-if="!isMerge">
          <div class="card-item">
            总价 ：¥{{ orderDetail["price_total"] | pricefn }}
          </div>
          <!-- <div class="card-item"
                         v-show="orderDetail['preferential_description']"
                         style="justify-content: flex-start;">
                        {{orderDetail['preferential_description']}} ：<span style="color: #F63D30">-¥{{(orderDetail['discount_amount']/100).toFixed(2)}}</span>
                    </div> -->
          <div
            class="card-item"
            v-for="item in orderDetail['discounts']"
            :key="item.name"
            style="justify-content: flex-start"
          >
            {{ item.name }} ：<span style="color: #f63d30"
              >-¥{{ item.price | pricefn }}</span
            >
          </div>
          <div class="card-item" v-show="orderDetail['actual_amount_paid']">
            {{ orderDetail["state"] === "waiting" ? "应付 ：" : "实付："
            }}<span style="color: #f63d30"
              >¥{{ orderDetail["actual_amount_paid"] | pricefn }}</span
            >
            <span style="color: #f63d30; opacity: 0.5"
              >（已优惠¥{{
                (orderDetail["discount_amount"] / 100).toFixed(2)
              }}）</span
            >
          </div>
        </template>
      </div>
    </div>
    <div class="box" v-if="orderDetail.id">
      <div class="card-title">收货人信息</div>
      <div class="card-body">
        <div class="card-item">收货人：{{ orderDetail["user_name"] }}</div>
        <div class="card-item">联系电话：{{ orderDetail["user_phone"] }}</div>
        <div
          class="card-item"
          style="align-items: flex-start; justify-content: flex-start"
          v-if="orderDetail['user_address']"
        >
          <div class="_left">收货地址：</div>
          <div class="_right" style="word-break: break-all">
            {{ orderDetail["user_address"].replace(/(\s)*\/(\s*)/g, "") }}
          </div>
        </div>
      </div>
    </div>
    <div class="box" id="packageTrackInfo" style="margin-bottom: 0">
      <div class="card-title card-title-blue">快递信息</div>
      <div class="card-body">
        <div v-if="orderDetail['express_no']">
          <div class="card-item">
            配送方式：{{ orderDeliveries[orderDetail["delivery"]] }}
          </div>
          <div class="card-item">
            快递公司：{{ orderDetail["express_service"] }}
          </div>
          <div class="card-item">
            <span class="_left">快递单号：{{ orderDetail["express_no"] }}</span>
            <div class="_right">
              <button
                class="btn btn-small cp-btn clip-btn"
                :data-clipboard-text="orderDetail['express_no']"
              >
                复制
              </button>
            </div>
          </div>
          <template v-if="expressLog && expressLog.length">
            <div id="package-info-detail">
              <div
                class="package-info-item"
                v-for="(item, index) in expressLog"
                :key="index + item.time"
              >
                <div class="package-datetime">
                  <div class="package-time">{{ item.time }}</div>
                  <div class="package-date">{{ item.date }}</div>
                </div>
                <div class="package-content-container">
                  <div class="package-content">{{ item.status }}</div>
                </div>
              </div>
            </div>
            <div style="text-align: center; padding-bottom: 25px">
              <div class="shipping-tip">
                本信息由快递公司提供，本应用仅提供展示
              </div>
            </div>
          </template>
          <div style="text-align: center; padding-bottom: 25px" v-else>
            <div class="shipping-tip">暂无快递信息</div>
          </div>
        </div>
        <div style="text-align: center; padding: 15px 0" v-else>
          <div class="shipping-tip">暂无快递信息</div>
        </div>
      </div>
    </div>

    <!-- <div style="height: 60px;width: 100%;"></div> -->

    <save-photo
      :orderState="orderDetail.state"
      :tqm="orderDetail['extract_code']"
      :orderId="orderDetail.id"
      :popupVisible="popupVisible"
      @popupVisiblefn="(bol)=>showPopup(bol)"
    ></save-photo>
    <div class="savebtnp" @click="showPopup(true)" v-if="canSave">
      保存电子照
    </div>
  </div>
</template>

<script>
import api from "../api/api";
import Moment from "moment";
import { ORDER_DELIVERY, ORDER_STATE } from "../utils/const";
import { Popup, Toast } from "mint-ui";
import SavePhoto from "../components/savePhoto.vue";
import Loading from "../components/Loading";
import IconKey from "../components/Icon/IconKey";
import IconMail from "../components/Icon/IconMail";
import IconCross from "../components/Icon/IconCross";
import oditem from "@/components/oditem";
export default {
  components: {
    IconCross,
    IconMail,
    IconKey,
    Loading,
    oditem,
    SavePhoto,
  },
  data() {
    return {
      popupVisible: false,
      emailAddr: "",
      clipboard: null,
      orderId: null,
      isLoadingDetail: false,
      orderDetail: {},
      orderStates: ORDER_STATE,
      orderDeliveries: ORDER_DELIVERY,
      expressLog: null,
      isMerge: false,
      pattern:
        /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
    };
  },
  filters: {
    pricefn(val) {
      return (val / 100).toFixed(2);
    },
  },
  methods: {
    showPopup(isShow = false) {
      this.popupVisible = false;
      this.popupVisible = isShow;
    },
    initClipboard() {
      const echoSuccess = (e) =>
        console.log(`${e.action} success! value is: \n${e.text}`);
      import(/* webpackChunkName: "clipboard" */ "clipboard").then(
        ({ default: ClipboardJS }) => {
          this.clipboard = new ClipboardJS(".clip-btn");
          this.clipboard.on("success", (e) => {
            echoSuccess(e);
            Toast("已复制到剪贴板");
          });
        }
      );
    },
    getExpressLog() {
      return api.getExpressLog(this.orderId).then(({ data }) => {
        const expressLogList = data.reduce(
          (arr, curr, currIndex, totalArray) => {
            const currDate = curr.time;

            arr.push({
              time: Moment(currDate).format("HH:mm"),
              date: Moment(currDate).format("YYYY-MM-DD"),
              status: curr.status,
            });

            return arr;
          },
          []
        );

        this.expressLog = [...expressLogList];
      });
    },

    getOrderDetail(orderId) {
      this.isLoadingDetail = true;
      return api
        .getOrderDetail(orderId)
        .then(({ data }) => {
          console.log(data);
          this.orderDetail = data;
        })
        .then(() => (this.isLoadingDetail = false));
    },
  },
  created() {
    console.log(';111111')
    this.initClipboard();
  },
  activated() {
    this.orderId = this.$route.params.order_id;
    this.getOrderDetail(this.orderId).catch(() => {
      this.$router.go(-1);
      Toast("获取订单失败");
    });
    console.log(this.$route.query.isMerge, !!this.$route.query.isMerge);
    this.isMerge = !!this.$route.query.isMerge;
    this.getExpressLog();
  },

  beforeDestroy() {
    this.clipboard.destroy();
  },

  deactivated() {
    this.orderDetail = {};
    this.emailAddr = "";
    this.orderId = null;
    this.expressLog = null;
    this.popupVisible = false;
  },

  computed: {
    hunbol() {
      return (
        this.orderDetail.extra &&
        (this.orderDetail.extra.isMarriage ||
          this.orderDetail.extra.phototype === "marriage")
      );
    },
    canSave() {
      return (
        this.orderDetail["state"] === "shipping" ||
        this.orderDetail["state"] === "processing" ||
        this.orderDetail["state"] === "completed"
      );
    },

    isLoading() {
      return this.isLoadingDetail;
    },

    orderTime() {
      let { created_at } = this.orderDetail;
      if (created_at) return Moment(created_at).format("YYYY-MM-DD HH:mm:ss");
      return "";
    },

    payedTime() {
      let { paid_at } = this.orderDetail;
      if (paid_at) return Moment(paid_at).format("YYYY-MM-DD HH:mm:ss");
      return "";
    },

    headImageUrl() {
      let { image_urls } = this.orderDetail;
      if (image_urls) return image_urls.single;

      return "";
    },
  },
};
</script>


<style>
.mint-toast {
  z-index: 2100 !important;
}
</style>


<style lang="scss" scoped>
button {
  outline: none;
  padding: 0;
  padding-top: 2px;
}

.mint-popup {
  background-color: transparent;
}

.popup-box {
  width: 327px;
  height: 295px;
  background-color: #fff;
  border-radius: 9px;
  transition: height 300ms ease-in-out;

  &.is-send-email {
    height: 275px;
  }

  .popup-box-header {
    text-align: center;
    position: relative;
    font-size: 16px;
    padding-top: 13px;
    margin-bottom: 25px;

    ._close {
      position: absolute;
      top: 6px;
      right: 7px;
      width: 25px;
      height: 25px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: transparent;
    }
  }

  .popup-box-footer {
    text-align: center;
    padding: 16px 0;

    .confirm-btn {
      width: 198px;
      height: 34px;
      background-color: rgba(57, 75, 229, 1);
      border-radius: 4px;
      color: #fff;
      border: 0;
      outline: none;
    }
  }

  .popup-box-container {
    width: 100%;
    overflow: hidden;

    .btn-groups {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .action-btn {
      border: 1.5px solid #8d99ff;
      color: #8d99ff;
      background-color: transparent;
      width: 124px;
      height: 34px;
      border-radius: 20px;
      transition: color 200ms;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      & + .action-btn {
        margin-left: 35px;
      }

      &.active {
        border-color: #394be5;
        color: #394be5;
      }
    }

    .tip-row {
      height: 34px;
      margin-top: 11px;
      background-color: rgba(221, 232, 255, 1);
      line-height: 34px;
      text-align: center;
      font-size: 12px;
      color: rgba(57, 75, 229, 1);
      font-weight: normal;
      position: relative;
      z-index: 10;

      ._brick {
        content: "";
        position: absolute;
        display: inline-block;
        width: 16px;
        height: 16px;
        transform: rotate(45deg);
        background-color: rgba(221, 232, 255, 1);
        top: -5px;
        left: 80px;
        z-index: -1;
        transition: left 300ms ease-out;

        &._brick-email {
          left: 240px;
        }
      }
    }

    ._row {
      width: 100%;
      height: 46px;
      display: flex;
      box-sizing: border-box;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid rgba(151, 151, 151, 0.3);
      padding: 0 16px;

      &._big {
        height: 58px;
      }

      input[type="email"] {
        text-align: right;
        font-size: 12px;
        color: rgba(144, 144, 144, 1);
        outline: none;
      }

      ._key {
        font-size: 14px;
        color: rgba(55, 55, 55, 1);
      }

      ._value {
        font-size: 12px;
        color: rgba(144, 144, 144, 1);
      }
    }
  }
}

.card-item {
  padding-bottom: 12px;
  font-size: 14px;
  color: #363636;
  letter-spacing: 0.82px;
  display: flex;
  align-items: center;

  ._left {
    flex-shrink: 0;
  }

  &:last-child {
    padding-bottom: 16px;
  }

  &:first-child {
    padding-top: 16px;
  }
}

#order-detail {
  padding: 16px 0 73px;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  .order-header {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    padding: 16px;

    .order-image-container {
      width: 52px;
      height: 74px;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .hun-image-container {
      width: 113px;
      height: 74px;
      flex-shrink: 0;
      margin-right: 8px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .order-info {
      width: calc(100% - 62px);
      position: relative;
      padding-bottom: 22px;
    }

    .info-line {
      display: flex;
      align-items: baseline;
      justify-content: space-between;

      .spec-name {
        width: 100%;
        padding-right: 4px;
      }

      .order-status {
        flex-shrink: 0;
      }
    }

    .save-btn {
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 12px;
      width: 80px;
      height: 22px;
    }
  }
}

.small-btn-container {
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
}

.card-title {
  font-size: 14px;
  font-weight: bold;
  color: #363636;
  padding: 14px 0;
  border-bottom: 1px solid rgba(151, 151, 151, 0.3);
  padding-left: 16px;
}

.card-title-blue {
  color: #4455e4;
}

.card-body {
  padding-left: 16px;
  padding-right: 16px;
}

#package-info-detail {
  padding-top: 17px;
}

.package-info-item {
  display: flex;
  position: relative;
  line-height: 20px;
  font-size: 14px;
  color: #b7b7b7;
  letter-spacing: 0.7px;

  &:first-child {
    color: #363636;

    .package-time {
      color: #363636;
    }

    .package-date {
      color: rgba(183, 183, 183, 1);
    }
  }

  &:last-child > .package-content-container {
    border-left: 1px solid white;
  }
}

.package-content-container {
  flex: 1;
  margin-left: 13px;
  padding-left: 12px;
  padding-bottom: 10px;
  margin-bottom: 14px;
  min-height: 50px;
  border-left: calc(1px * 2) solid rgba(221, 221, 221, 0.5);
  position: relative;

  &::before {
    content: "";
    width: calc(1px * 4);
    height: calc(1px * 4);
    border-radius: 50%;
    background: #b7b7b7;
    position: absolute;
    display: inline-block;
    left: calc(-1px * 3);
    top: -8px;
  }
}

.package-content {
  position: relative;
  font-size: 14px;
  top: -14px;
  word-break: break-all;
}

.package-datetime {
  position: relative;
  top: -14px;

  .package-date {
    font-size: 12px;
  }
}

.card-item-with-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 9px;

  .left {
    flex-shrink: 0;
    max-width: calc(100% - 56px);
    word-break: break-all;
  }
}

.cp-btn {
  width: 56px;
  height: 20px;
  border-color: rgba(54, 54, 54, 0.7);
  color: rgba(54, 54, 54, 0.7);
  font-size: 12px;
  border-radius: 2px;
  padding-top: 2px;
}

.shipping-tip {
  font-size: 12px;
  color: rgba(132, 132, 132, 1);
  position: relative;
  display: inline-block;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 18px;
    height: 1px;
    top: 50%;
    background-color: rgba(132, 132, 132, 1);
  }

  &::before {
    left: -20px;
  }

  &::after {
    right: -20px;
  }
}

.package-time {
  text-align: right;
  font-size: 14px;
  color: rgba(183, 183, 183, 1);
}

.package-data {
  text-align: right;
  font-size: 12px;
  color: rgba(183, 183, 183, 1);
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #363636;
  font-weight: bold;
  height: 38px;
  box-sizing: border-box;
  padding: 0 16px;
  border-bottom: 0.5px solid rgba(151, 151, 151, 0.3);
  margin-bottom: 29px;
}
.topr {
  color: #394be5;
}
.middle {
  box-sizing: border-box;
  padding: 0 16px 16px;
}
.bottom {
  margin: 14px 16px;
  .btitle {
    font-size: 12px;
    color: rgba(54, 54, 54, 0.5);
  }
  .blistwrap {
    margin-top: 8px;
    box-sizing: border-box;
    padding: 16px;
    background-color: #f8fafe;
  }
}
.box {
  overflow: hidden;
}
.savebtnp {
  width: 343px;
  height: 44px;
  border-radius: 5px;
  font-size: 16px;
  background-color: #465ae0;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 19px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}
</style>
